<template>
    <div>
        <!-- TAB HEAD  -->
        <v-row>
            <v-col cols="6">
                <h1 class="headline font-weight-light mb-3">
                    <router-link
                        class="link-a"
                        :to="'/Inventory/Defective-Toner'"
                    >
                        DEFECTIVE</router-link
                    >
                    / PRINT
                </h1>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="6" class="text-right ">
                <v-btn rounded small @click="print()">
                    <v-icon class="mr-1" dark small>mdi-printer</v-icon>
                    Print</v-btn
                >
            </v-col>
        </v-row>

        <div id="printDiv">
            <!-- Main ใช้ทั้งสองอัน -->
            <div id="main">
                <v-row>
                    <v-col cols="12" class="text-center">
                        <div>
                            <span style="font-size:28px;"
                                >PACKINGLIST - เอกสารส่งอะไหล่
                            </span>
                        </div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="3" class="text-right">DATE SENT :</v-col>
                    <v-col
                        cols="3"
                        style="border-bottom: 1px dotted !important;"
                        >{{ data_print.created_date }}</v-col
                    >
                </v-row>
                <v-row>
                    <v-col cols="3" class="text-right">FROM :</v-col>
                    <v-col
                        cols="3"
                        style="border-bottom: 1px dotted !important;"
                        >{{ data_print.from }}</v-col
                    >
                    <v-col cols="3" class="text-right">TO :</v-col>
                    <v-col
                        cols="3"
                        style="border-bottom: 1px dotted !important;"
                        >{{ data_print.to }}</v-col
                    >
                </v-row>

                <!-- <v-row class="mt-5 mb-1">
                    <v-col cols="12" class="text-center">
                        <div>
                            <span style="font-size:22px;"
                                >PARTNO : M0H50 Color | QTY :
                                {{ data_print.m0_h50.length }} PARTNO : M0H51 |
                                QTY : {{ data_print.m0_h51.length }} PARTNO
                                X4E75 Black | QTY :
                                {{ data_print.x4_e75.length }}
                            </span>
                        </div>
                    </v-col>
                </v-row> -->

                <v-row justify="center" class="mt-5">
                    <v-col cols="1"></v-col>
                    <v-col cols="3">
                        <table style="border-collapse:collapse;" border="1">
                            <tr>
                                <td align="center" width="40%">
                                    <b>M0H50 Color</b> QTY :
                                    {{ data_print.m0_h50.length }}
                                </td>
                            </tr>
                            <tbody
                                v-for="(row_m0_h50, i) in data_print.m0_h50"
                                :key="i"
                            >
                                <tr>
                                    <td align="center" width="40%">
                                        {{ row_m0_h50.singlepart }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                    <v-col cols="3">
                        <table style="border-collapse:collapse;" border="1">
                            <tr>
                                <td align="center" width="40%">
                                    <b>M0H51 Black</b> QTY :
                                    {{ data_print.m0_h51.length }}
                                </td>
                            </tr>
                            <tbody
                                v-for="(row_m0_h51, ii) in data_print.m0_h51"
                                :key="ii"
                            >
                                <tr>
                                    <td align="center" width="40%">
                                        {{ row_m0_h51.singlepart }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                    <v-col cols="3">
                        <table style="border-collapse:collapse;" border="1">
                            <tr>
                                <td align="center" width="40%">
                                    <b>X4E75 Black</b> QTY :
                                    {{ data_print.x4_e75.length }}
                                </td>
                            </tr>
                            <tbody
                                v-for="(row_x4_e75, iii) in data_print.x4_e75"
                                :key="iii"
                            >
                                <tr>
                                    <td align="center" width="40%">
                                        {{ row_x4_e75.singlepart }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>

                <v-row justify="end" class="mt-5 mr-5">
                    <v-col cols="9"></v-col>
                    <v-col
                        cols="3"
                        style="border-bottom: 1px dotted !important;"
                    ></v-col>
                </v-row>
                <v-row justify="end" class="mr-5">
                    <v-col cols="9"></v-col>
                    <v-col cols="3" class="text-center">{{ fullname }}</v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    mounted() {
        this.transfer_id = this.$route.params.transfer_id
        this.get_data()
        this.fullname = localStorage.fullname
    },
    computed: {
        ...mapState(["isLoading"]),
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        async get_data() {
            this.mutateIsLoading()
            await axios
                .get(url + "srfr/sent-claim/" + this.transfer_id)
                .then((response) => {
                    // console.log(response)
                    this.mutateIsLoading()
                    this.data_print = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        print() {
            const localOptions = {
                styles: [
                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                    "https://aitt.netlify.app/landscape.css",
                ],
            }

            this.$htmlToPaper("printDiv", localOptions, () => {
                // console.log(localOptions)
                // console.warn("done landscape")
            })
        },
    },
    data() {
        return {
            data_print: [],
            transfer_id: 0,
            fullname: "",
        }
    },
}
</script>

<style scoped>
.border-bottom-a {
    border-bottom: 1px dotted !important;
}
</style>
